import { AppHeaderStyle, HeaderStyle, Section } from "./styles";
import {
  NewsToday,
  Liveblogs,
  Menu,
  HeadingDefault,
  UrgentModule,
} from "./components";
import { useAppTrue } from "@/hooks/index";
import Banner from "@/widgets/Banner/Templates/Banner";
import { ContainerAuto } from "@/shared/ContainerAuto";
import Script from "next/script";
import { useContext,useState,useEffect } from "react";
import TemplateContext from "@/context/Template/TemplateContext";
import SeparatorLinksRecipes from "@/shared/SeparatorLinksRecipes";

const Header = (props) => {
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.innerWidth > 1024) {
        setScroll(window.scrollY > 416);
      } else {
        setScroll(window.scrollY > 36);
      }
    });
  }, []);
  
  const dataContext = useContext(TemplateContext);
  const { content: formatContent, ...rest } = dataContext || {};

  if (formatContent?.dataHeader) {
    props = {
      ...props,
      ...formatContent?.dataHeader,
    };
  }
  
  const {
    urgent = [],
    liveblogs,
    menu,
    bannerHorizantalOneEnable = true,
    subheaderEnable = true,
    isNews = false,
    isHome = false,
    showGoolgeOneTap = true,
    newsToday,
    megaWithHtml = false,
    nameIcon = "logoClarin",
    titleHeader = "",
    logoUrlSection = "/",
    TAGTitleHeader = "h1",
    showLinkRecipes = false,
    showLiveblog = true,
    heightIcon,
    cssClass = "",
  } = props;

  const menulateral = menu?.menulateral?.item?.items ?? [];
  const menuheader = menu?.menuheader?.item?.items ?? [];
  const menuHeaderMobileHome = menu?.menuheadermobile?.item?.items ?? [];

  const sectionData = props.sectionData
    ? props.sectionData
    : { name: "", url: null };

  const isApp = useAppTrue();

  if (isApp)
    return (
      <>
        <AppHeaderStyle>
          <div className="bannerTopHeader">
            <Banner isPreview={props.isPreview} slotId={"horizontal1"} />
          </div>
        </AppHeaderStyle>
        <Script src="/js/appClarin.js" strategy="beforeInteractive" />
      </>
    );

  return (
    <>
      <HeaderStyle>
        {bannerHorizantalOneEnable && (
          <div className={`bannerTopHeader ${
            scroll ? "sticky" : "no-sticky"
          }`}>
            <Banner isPreview={props.isPreview} slotId={"horizontal1"} />
          </div>
        )}
        {newsToday && <NewsToday noticiashoy={newsToday} />}
        <HeadingDefault
          isHome={isHome}
          isNews={isNews}
          sectionData={sectionData}
          suscriptionPrice={
            menu?.suscriptionPrice ? menu?.suscriptionPrice : ""
          }
          menulateral={menulateral}
          subheaderEnable={subheaderEnable}
          showGoolgeOneTap={showGoolgeOneTap}
          isPreview={props.isPreview}
          nameIcon={nameIcon}
          titleHeader={titleHeader}
          TAGTitleHeader={TAGTitleHeader}
          logoUrlSection={logoUrlSection}
          heightIcon={heightIcon}
          cssClass={cssClass}
        />
        {isHome && (
          <Menu
            menuheader={menuheader}
            sectionData={sectionData}
            menuHeaderMobileHome={menuHeaderMobileHome}
            suscriptionPrice={
              menu?.suscriptionPrice ? menu?.suscriptionPrice : ""
            }
            isPreview={props.isPreview ? props.isPreview : false}
          />
        )}

        {!megaWithHtml && subheaderEnable && showLiveblog ? (
          <Liveblogs liveblogs={liveblogs || []} />
        ) : (
          <></>
        )}

        {Array.isArray(urgent) && urgent.length > 0 && (
          <UrgentModule urgent={urgent} />
        )}
        {showLinkRecipes && <SeparatorLinksRecipes />}
        {isNews && subheaderEnable && !megaWithHtml ? (
          <ContainerAuto>
            <Section
              className="SectionSeparator"
              href={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/${
                sectionData.url != undefined ? sectionData.url : ""
              }`}
            >
              {sectionData.name}
            </Section>
          </ContainerAuto>
        ) : (
          <></>
        )}
      </HeaderStyle>
    </>
  );
};

export default Header;
